import './dom-53c9635b.js';
import { i as isArray } from './isArray-8eeb52b9.js';
import { i as isNil } from './isNull-7ae26d1d.js';

/**
 * Converts the `value` to an array literal.
 */
const toArray = value => {
  if (isNil(value)) {
    return [];
  }
  if (isArray(value)) {
    return value;
  }
  return [value];
};

export { toArray as t };
